import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import {
    CircularProgress,
    Fade,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
class BusinessHoursPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            closeVerification: false
        };
    }

    handleClose = () => {
        this.props.closePopup();
    };

    handleError = params => {
        this.setState(params);
    };

    render() {
        const { data } = this.props;
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/user/dashboard`
            });
            // return <Redirect to={'/user/dashboard'} />;
        }
        return (
            <div>
                <Dialog
                    TransitionComponent={Fade}
                    className="service-modal"
                    open={this.props.isVisible}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <div
                        className="modal-header dir-pop-head"
                        style={{
                            backgroundColor: this.props.theme.palette.primary
                                .main
                        }}
                    >
                        <h4 className="dialog-heading">
                            {' '}
                            <FormattedMessage
                                id="workinghour.title"
                                defaultMessage="Working Hours"
                            />
                        </h4>
                    </div>
                    <div className="modal-body dir-pop-body">
                        <DialogContent className="service-from-body">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <FormattedMessage
                                                id="workinghour.day"
                                                defaultMessage="Day"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedMessage
                                                id="workinghour.openat"
                                                defaultMessage="Opens At"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedMessage
                                                id="workinghour.closeat"
                                                defaultMessage="Closes At"
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((n, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell>{n.day}</TableCell>
                                                {n.status ? (
                                                    <React.Fragment>
                                                        <TableCell>
                                                            {n.startTime}
                                                        </TableCell>
                                                        <TableCell>
                                                            {n.endTime}
                                                        </TableCell>
                                                    </React.Fragment>
                                                ) : (
                                                    <TableCell
                                                        colSpan="2"
                                                        style={{
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        <FormattedMessage
                                                            id="workinghour.closed"
                                                            defaultMessage="Closed"
                                                        />
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </DialogContent>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(
        null,
        actions
    )
);
export default composedHOC(BusinessHoursPopup);



// WEBPACK FOOTER //
// ./src/components/Providers/BusinessHoursPopup.js